<div id="dashboard-project" class="page-layout simple right-sidebar" fxLayout="row">
    <!-- CENTER -->
    <div class="center" fusePerfectScrollbar>

        <!-- HEADER -->
        <div 
            class="header accent p-24 pb-0" 
            fxLayout="column" 
            fxLayoutAlign="space-between"
        >
            <div fxLayout="row" fxLayoutAlign="space-between start">
                <span 
                    class="mat-display-1 my-0 my-sm-24 welcome-message" 
                    [@animate]="{value:'*',params:{x:'50px'}}">
                    Dashboard Renda Variável
                </span>
            </div>            
        </div>
        <!-- / HEADER -->

        <div class="content">

            <div dynamicHeight>

                <mat-card class="dash-card">
                    <!-- Filtros -->
                    <mat-card-header>
                        <div 
                            class="pl-16 pr-8 py-16 h-52" 
                            fxLayout="row"
                            fxLayoutAlign="space-between center"
                            *ngIf="this.user.role_id == 7 || this.user.role_id == 4 || this.user.role_id == 1 || this.user.role_id == 2 ">
                            <mat-label>Regional:</mat-label>
                            <mat-form-field style="margin-left: 5px;">
                                <mat-select 
                                    class="simplified font-size-16"
                                    aria-label="Change range"
                                    [(ngModel)]="model.regional_id"
                                    [formControl]="regional_id"
                                    (selectionChange)="selectRegional($event)">                            
                                    <mat-option 
                                        *ngFor="let regional of listRegional"
                                        [value]="regional.id">
                                        {{regional.nome}}
                                    </mat-option>                            
                                </mat-select>
                                <mat-spinner diameter="20" *ngIf="loadingSpinnerRegional"></mat-spinner>
                            </mat-form-field>            
                        </div> 

                        <div
                            class="pl-16 pr-8 py-16 h-52" 
                            fxLayout="row"
                            fxLayoutAlign="space-between center"
                            *ngIf="this.user.role_id == 7 || this.user.role_id == 4 || this.user.role_id == 1 || this.user.role_id == 2 || user.tipo_usuario_id == 3">
                            <mat-label>Escritório:</mat-label>
                            <mat-form-field style="margin-left: 5px;">
                                <mat-select 
                                    class="simplified font-size-16"
                                    aria-label="Change range"
                                    [(ngModel)]="model.escritorio_id"
                                    [formControl]="escritorio_id"
                                    (selectionChange)="selectEscritorio($event)">
                                    <mat-option 
                                        *ngFor="let escritorio of listEscritorio"
                                        [value]="escritorio.id">
                                        {{escritorio.nome_fantasia}}
                                    </mat-option>                            
                                </mat-select>
                                <mat-spinner diameter="20" *ngIf="loadingSpinnerEscritorio"></mat-spinner>
                            </mat-form-field>            
                        </div>
                        
                        <div 
                            class="pl-16 pr-8 py-16 h-52" 
                            fxLayout="row"
                            fxLayoutAlign="space-between center"
                            *ngIf="this.user.role_id != 5">
                            <mat-label>Assessor:</mat-label>
                            <mat-form-field>                   
                                <mat-select 
                                    class="simplified font-size-16"
                                    aria-label="Change range"
                                    [formControl]="assessor_id"
                                    (selectionChange)="selectAssessor($event)">
                                    <mat-option value="">TODOS</mat-option>
                                    <mat-optgroup 
                                        *ngFor="let escritorio of listEscritorio" 
                                        [label]="escritorio.nome_fantasia">
                                        <mat-option 
                                        *ngFor="let usuario of escritorio.usuarios" 
                                        [value]="usuario.id">
                                        {{usuario.name}}
                                        </mat-option>
                                    </mat-optgroup>
                                </mat-select>
                                <mat-spinner diameter="20" *ngIf="loadingSpinnerAssessor"></mat-spinner>
                            </mat-form-field>
                        </div>              
                        
                    </mat-card-header>
                    <!-- / Filtros -->

                    <mat-card-content>
                        <div 
                            class="widget-group p-12" 
                            fxLayout="row wrap" 
                            fxFlex="100" 
                            *fuseIfOnDom 
                            [@animateStagger]="{value:'50'}">

                            <!----------        CLIENTES        --------->
                        
                            <!-- Total Clientes -->
                            <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"                                
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"      
                                fxFlex.gt-xs="50"                           
                                fxFlex.gt-md="33"
                                *ngIf="isEmptyObject(clienteTotal)"
                            >
                            </ngx-shimmer-loading>

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!isEmptyObject(clienteTotal)"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Clientes RV</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>   
                                    
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            (click)="openModal('TOTAL_CLIENTES')"
                                            style="cursor: pointer;">
                                            {{clienteTotal.conversion.value}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Total de Clientes
                                        </div>
                                    </div>   
                                    
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <canvas 
                                            baseChart
                                            [data]="{
                                                labels: clienteTotal.labels,
                                                datasets: clienteTotal.datasets
                                            }"
                                            [options]="clienteTotal.options"
                                            [type]="clienteTotal.chartType"
                                            (chartClick)="onChartClick($event, 'TOTAL_CLIENTES')">
                                        </canvas>
                                    </div>
                                
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        Total cliente operando através da RV Prosperidade e grafico dos ultimos 5 meses
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Total Clientes -->

                            <!-- Novos Clientes -->
                            <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"                                
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"      
                                fxFlex.gt-xs="50"                           
                                fxFlex.gt-md="33"
                                *ngIf="isEmptyObject(clienteNovos)"
                            >
                            </ngx-shimmer-loading>

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!isEmptyObject(clienteNovos)"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Clientes RV</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>   
                                    
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            (click)="openModal('NOVOS_CLIENTES')"
                                            style="cursor: pointer;">
                                            {{clienteNovos.conversion.value}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Novos Clientes
                                        </div>
                                    </div>   
                                    
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <canvas 
                                            baseChart
                                            [data]="{
                                                labels: clienteNovos.labels,
                                                datasets: clienteNovos.datasets
                                            }"
                                            [options]="clienteNovos.options"
                                            [type]="clienteNovos.chartType"
                                            (chartClick)="onChartClick($event, 'CLIENTE_NOVOS')">
                                        </canvas>
                                    </div>
                                
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        Novos clientes cadastrados na RV PROSPERIDADE no mês vigente e as informações do grafico mostra dos últimos 5 meses
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Novos Clientes -->                

                            <!-- Clientes Inativos -->
                            <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"                                
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"      
                                fxFlex.gt-xs="50"                           
                                fxFlex.gt-md="33"
                                *ngIf="isEmptyObject(clienteInativos)"
                            >
                            </ngx-shimmer-loading>

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!isEmptyObject(clienteInativos)"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Clientes RV</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>   
                                    
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            (click)="openModal('CLIENTE_INATIVO')"
                                            style="cursor: pointer;">
                                            {{clienteInativos.conversion.value}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Clientes Inativos
                                        </div>
                                    </div>   
                                    
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <canvas 
                                            baseChart
                                            [data]="{
                                                labels: clienteInativos.labels,
                                                datasets: clienteInativos.datasets
                                            }"
                                            [options]="clienteInativos.options"
                                            [type]="clienteInativos.chartType"
                                            (chartClick)="onChartClick($event, 'CLIENTE_INATIVO')">
                                        </canvas>
                                    </div>
                                
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">

                                    <button 
                                        mat-icon-button 
                                        fuseWidgetToggle 
                                        class="fuse-widget-flip-button"
                                        aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        Clientes que não realizaram operações RV nos ultimos 60 dias via RV Prosperidade (Boleta Única e/ou Boletas das estratégias) e as informações do grafico mostra os últimos 5 meses.
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Clientes Inativos -->

                            <!----------     /  CLIENTES        ---------->

                            <!----------       Financeiro MRV        --------->

                            <!-- Total Disponivel MRV -->
                            <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"                                
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"      
                                fxFlex.gt-xs="50"                           
                                fxFlex.gt-md="33"
                                *ngIf="isEmptyObject(vlr_mrv)"
                            >
                            </ngx-shimmer-loading>

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!isEmptyObject(vlr_mrv)"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">R$</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>   
                                    
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            (click)="openModal('TOTAL_DISPONIVEL')"
                                            style="cursor: pointer;">
                                            {{ vlr_total_invest | number : '1.2-2'}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Total Ativo MRV
                                        </div>
                                    </div>   
                                    
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <canvas 
                                            baseChart
                                            [data]="{ 
                                                labels: vlr_mrv.labels, 
                                                datasets: vlr_mrv.datasets 
                                            }"
                                            [options]="vlr_mrv.options"
                                            [type]="vlr_mrv.chartType"
                                            (chartClick)="onChartClick($event, 'MRV_DISPONIVEL')">
                                        </canvas>

                                    </div>
                                    
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        Total efetivamente liquido e disponível para operações através da RV Prosperidade, utilizamos saldo máximo disponivel em 
                                        abril/20 mais ajustes na boleta RV (+/-) mais clientes novos em RV e boletas unicas de vendas e gráfico dos ultimos 5 meses
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Total Disponivel MRV -->

                            <!-- Custódia Hoje -->

                            <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"                                
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"      
                                fxFlex.gt-xs="50"                           
                                fxFlex.gt-md="33"
                                *ngIf="isEmptyObject(vlr_custodia)"
                            >
                            </ngx-shimmer-loading>

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!isEmptyObject(vlr_custodia)"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">R$</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>   
                                    
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            (click)="openModal('CUSTODIA_HOJE')"
                                            style="cursor: pointer;">
                                            {{ totalCustodia | number : '1.2-2'}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Custódia Hoje
                                        </div>
                                    </div>   
                                    
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <canvas 
                                            baseChart
                                            [data]="{ 
                                                labels: vlr_custodia.labels, 
                                                datasets: vlr_custodia.datasets 
                                            }"
                                            [options]="vlr_custodia.options"
                                            [type]="vlr_custodia.chartType"
                                            (chartClick)="onChartClick($event, 'CUSTODIA_HOJE')">
                                        </canvas>
                                    </div>
                                    
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        Total em custódia via RV Prosperidade com o valor atualizado , e as informações do grafico mostra dos últimos 5 meses
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Custódia Hoje -->                

                            <!-- Novo RV -->

                            <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"                                
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"      
                                fxFlex.gt-xs="50"                           
                                fxFlex.gt-md="33"
                                *ngIf="isEmptyObject(vlr_novo)"
                            >
                            </ngx-shimmer-loading>

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!isEmptyObject(vlr_novo)"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">R$</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>   
                                    
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            (click)="openModal('NOVO_RV')"
                                            style="cursor: pointer;">
                                            {{vlr_novo.conversion.value | number : '1.2-2'}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Valor Novo RV
                                        </div>
                                    </div>   
                                    
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <canvas 
                                            baseChart
                                            [data]="{ 
                                                datasets: vlr_novo.datasets, 
                                                labels: vlr_novo.labels 
                                            }"
                                            [options]="vlr_novo.options"
                                            [type]="vlr_novo.chartType"
                                            (chartClick)="onChartClick($event, 'MRV_NOVO')">
                                        </canvas>
                                    </div>
                                    
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">

                                    <button 
                                        mat-icon-button 
                                        fuseWidgetToggle 
                                        class="fuse-widget-flip-button"
                                        aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        Saldo dos recursos ajustados nas boletas RV ( +/- ) + novas boletas registradas  em RV, e as informações do grafico mostra dos últimos 5 meses
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Novo RV -->

                            <!----------     /   Financeiro MRV        --------->

                            <!----------      Boletas MRV       --------->

                            <!-- Total Boletado -->
                            <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"                                
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"      
                                fxFlex.gt-xs="50"                           
                                fxFlex.gt-md="33"
                                *ngIf="isEmptyObject(vlr_total_boletado)"
                            >
                            </ngx-shimmer-loading>

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!isEmptyObject(vlr_total_boletado)"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Boleta</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>   
                                    
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            (click)="openModal('TOTAL_BOLETADO')"
                                            style="cursor: pointer;">
                                            {{ total_boletado | number : '1.2-2'}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                        Total Boletado
                                        </div>
                                    </div>   
                                    
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <canvas 
                                            baseChart
                                            [data]="{
                                                datasets: vlr_total_boletado.datasets, 
                                                labels: vlr_total_boletado.labels
                                            }"
                                            [options]="vlr_total_boletado.options"
                                            [type]="vlr_total_boletado.chartType"
                                            (chartClick)="onChartClick($event, 'BOLETA_TOTAL')">
                                        </canvas>
                                    </div>
                                    
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        Valor total das boletas de compra (Boleta de Alocação estrategica e boleta unica de compra) disponibilizado pelo cliente para operarmos e grafico dos ultimos 5 meses.
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Total Boletado -->

                            <!-- Boleta Disponivel -->

                            <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"                                
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"      
                                fxFlex.gt-xs="50"                           
                                fxFlex.gt-md="33"
                                *ngIf="isEmptyObject(vlr_total_disponivel)"
                            >
                            </ngx-shimmer-loading>

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!isEmptyObject(vlr_total_disponivel)"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Boleta</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>   
                                    
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            (click)="openModal('BOLETA_DISPONIVEL')"
                                            style="cursor: pointer;">
                                            {{ vlr_boletasFO | number : '1.2-2'}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Disponível
                                        </div>
                                    </div>   
                                    
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <canvas 
                                            baseChart
                                            [data]="{
                                                datasets: vlr_total_disponivel.datasets, 
                                                labels: vlr_total_disponivel.labels
                                            }"
                                            [options]="vlr_total_disponivel.options"
                                            [type]="vlr_total_disponivel.chartType"
                                            (chartClick)="onChartClick($event, 'BOLETA_DISPONIVEL')">
                                        </canvas>
                                    </div>
                                    
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        Total de boletas A OPERAR em RV (  em saldo conta XP ) Potencial de receita vigente, e as informações do grafico mostra dos últimos 5 meses
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Boleta Disponivel -->                

                            <!-- Boleta Executadas -->

                            <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"                                
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"      
                                fxFlex.gt-xs="50"                           
                                fxFlex.gt-md="33"
                                *ngIf="isEmptyObject(vlr_total_executado)"
                            >
                            </ngx-shimmer-loading>

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!isEmptyObject(vlr_total_executado)"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Boleta</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>   
                                    
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            (click)="openModal('BOLETAS_EXECUTADAS')"
                                            style="cursor: pointer;">
                                            {{vlr_boletas | number : '1.2-2'}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Executadas
                                        </div>
                                    </div>   
                                    
                                    <div class="h-96 w-100-p">
                                        <canvas 
                                            baseChart
                                            [data]="{
                                                datasets: vlr_total_executado.datasets, 
                                                labels: vlr_total_executado.labels 
                                            }"
                                            [options]="vlr_total_executado.options"
                                            [type]="vlr_total_executado.chartType"
                                            (chartClick)="onChartClick($event, 'BOLETA_EXECUTADO')">
                                        </canvas>
                                    </div>
                                    
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">

                                    <button 
                                        mat-icon-button 
                                        fuseWidgetToggle 
                                        class="fuse-widget-flip-button"
                                        aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        Total de boletas RV executadas no mês, e as informações do grafico mostra dos últimos 5 meses
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Boleta Executadas -->

                            <!----------     /   Boletas MRV      --------->  
                            
                            
                            <!----------     Gestão        --------->

                            <!-- Saldo Disponivel -->
                            <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"                                
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"      
                                fxFlex.gt-xs="50"                           
                                fxFlex.gt-md="25"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading>

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="25"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Gestão</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>   
                                    
                                    <div 
                                        class="pt-8 pb-32" 
                                        fxLayout="column" 
                                        fxLayoutAlign="center center"
                                        style="margin-top: 30px;">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            (click)="redirectListaDisponivel()" 
                                            style="cursor: pointer;">
                                            {{ vlt_total_dispo | number : '1.2-2'}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Saldo Disponivel
                                        </div>
                                    </div>   
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        Saldo disponível na conta investimento da corretora x Boletas existentes, evidenciando o potencial oportunidades de ajustes na boleta;
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Saldo Disponivel  -->

                            <!-- Contas Negativas -->
                            <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"                                
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"      
                                fxFlex.gt-xs="50"                           
                                fxFlex.gt-md="25"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading>

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="25"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Gestão</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>   
                                    
                                    <div 
                                        class="pt-8 pb-32" 
                                        fxLayout="column" 
                                        fxLayoutAlign="center center"
                                        style="margin-top: 30px;">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            (click)="redirectListaNegativas()" 
                                            style="cursor: pointer;">
                                            <span  [ngClass]="{
                                                'red-fg':totalContasNegativas > 0 , 
                                                'light-blue-fg': totalContasNegativas == 0 }">
                                            {{ totalContasNegativas }}
                                            </span>
                                        </div>
                                        <div class="h3 secondary-text font-weight-500" style="text-align: center;">
                                            Clientes Conta Negativas
                                        </div>
                                    </div>   
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        Quantidade de Clientes que estão com contas negativas
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Contas Negativas -->

                            <!-- Pendências / Inconsistências -->

                            <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"                                
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"      
                                fxFlex.gt-xs="50"                           
                                fxFlex.gt-md="25"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading>

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="25"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center"
                                        >
                                        <div class="h3 secondary-text" fxLayout="row">Gestão</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>   
                                    
                                    <div 
                                        class="pt-8 pb-32" 
                                        fxLayout="column" 
                                        fxLayoutAlign="center center"
                                        style="margin-top: 30px;">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            (click)="openModal('PENDENCIAS')"
                                            style="cursor: pointer;">
                                            <span  [ngClass]="{
                                                'red-fg':qtd_cliente_pendente > 0 , 
                                                'light-blue-fg': qtd_cliente_pendente == 0 }">
                                                {{ qtd_cliente_pendente }}
                                            </span>
                                        </div>
                                        <div 
                                            class="h3 secondary-text font-weight-500" 
                                            style="text-align: center;">
                                            Pendências / Inconsistências
                                        </div>
                                    </div>   
                                    
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        Pendências e/ou inconsistências nas boletas ( Saldo insuficiente, push desabilitado, bovespa inativo... )
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- /Pendências / Inconsistências -->                

                            <!-- Projeção Receita -->
                            <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                [shape]="'square'"                                
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"      
                                fxFlex.gt-xs="50"                           
                                fxFlex.gt-md="25"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading>

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="25"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Gestão</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>   
                                    
                                    <div  
                                        class="pt-8 pb-32" 
                                        fxLayout="column" 
                                        fxLayoutAlign="center center"
                                        style="margin-top: 30px;">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            (click)="openModal('PROJECAO')"
                                            style="cursor: pointer;">
                                            {{ (vlr_projecao_mrc + vlr_projecao_fee_mrc) | number : '1.2-2'}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Projeção Receita
                                        </div>
                                    </div>   
                                    
                                    <div class="h-96 w-100-p">
                                        <!--todo: verificar-->
                                        <canvas
                                            baseChart
                                            [data]="vlr_comissao"
                                            [options]="vlr_comissao.options"
                                            [type]="vlr_comissao.chartType"
                                            [plugins]="vlr_comissao.plugins"
                                            (chartClick)="onChartClick($event, 'PROJECAO')">
                                        </canvas>
                                    </div>
                                    
                                </div>
                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">

                                    <button 
                                        mat-icon-button 
                                        fuseWidgetToggle 
                                        class="fuse-widget-flip-button"
                                        aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        Valor receita <b>líquida</b> RV com base nas operações 
                                        executadas pelos clientes via RV Prosperidade. Exceto impostos (16,33 %)
                                        Informações atualizadas em <b>D-2</b> 
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Projeção Receita -->

                            <!----------     /   Gestão      --------->
                    
                        </div>
                    </mat-card-content>
                </mat-card>   
            </div>
            
        </div>
    </div>
</div>